module.exports = __webpack_public_path__ + "img/session-organic-form-cinza.af96d5ba.png";